/** Church contact details – shared across site */

export const CHURCH_CONTACT = {
  email: 'philadelphiashalemag@gmail.com',
  phone: '(267) 984-3132',
  phoneTel: '+12679843132',
  pastorName: 'Pr. Sajan George',
  social: {
    facebook: {
      label: 'Facebook',
      url: 'https://www.facebook.com/psagchurch',
    },
    youtube: {
      label: 'YouTube',
      url: 'https://www.youtube.com/@psagchurch',
    },
    instagram: {
      label: 'Instagram',
      url: 'https://www.instagram.com/psagchurch/',
    },
  },
};
